import moment from 'moment';
import { EDULAI_ORANGE, RED } from '../styles/styleConsts';

export const TRIAL_LICENSE = 'TRIAL';
export const PRO_LICENSE = 'PRO';

export const LICENSES_LIST = [
  {
    value: TRIAL_LICENSE,
    label: 'Trial'
  },
  {
    value: PRO_LICENSE,
    label: 'Pro'
  }
];

export const EXPIRED_LICENSE_COLOR = RED;
export const WARNING_LICENSE_COLOR = EDULAI_ORANGE;

export const LICENSE_STATUS = {
  EXPIRED: 'EXPIRED',
  WARNING: 'WARNING',
  OK: '0K'
};

export const computeLicenseStatus = (license) => {
  if (!license) return LICENSE_STATUS.OK;
  const difference = moment(license.endDate).diff(moment(), 'days', true);
  switch (true) {
    case difference <= 0:
      return LICENSE_STATUS.EXPIRED;
    case difference <= 2:
      return LICENSE_STATUS.WARNING;
    default:
      return LICENSE_STATUS.OK;
  }
};

export const LICENSE_STATUS_COLOR = {
  [LICENSE_STATUS.OK]: '#D1D5DB',
  [LICENSE_STATUS.WARNING]: WARNING_LICENSE_COLOR,
  [LICENSE_STATUS.EXPIRED]: EXPIRED_LICENSE_COLOR
};

export const formatLicenseDate = (date) => {
  return moment(date).format('LLL');
};

export const hasLicense = (user) => {
  return user.license !== null && user.license.active;
};

export const hasExpiredLicense = (user) => {
  if (!hasLicense(user)) {
    return true;
  }
  return moment().isAfter(moment(user.license.endDate));
};
